import PropTypes from 'prop-types';
import React from 'react';
import { replaceImageServer } from '../helpers/image';

const StructuredData = ({ deals, isMobile }) => {
  const height = isMobile ? '275' : '384';
  const width = isMobile ? '412' : '573';

  const ListItem = ({ deal = {}, index }) => {
    return {
      '@type': 'ListItem',
      item: {
        '@type': 'Product',
        aggregateRating:
          (deal?.reviewSummary?.average &&
            deal?.reviewSummary?.total && {
              '@type': 'AggregateRating',
              ratingValue: `${deal?.reviewSummary?.average || 0}`,
              reviewCount: `${deal?.reviewSummary?.total || 0}`,
            }) ||
          null,
        image: [
          `${replaceImageServer({
            dealId: deal.id,
            height,
            image: deal?.image || deal.images[0],
            isSubSubCat: true,
            width,
          })}`,
        ],
        name: `${deal.headline}`,
        offers: {
          '@type': 'Offer',
          price: deal.originalPrice,
          priceCurrency: deal.currency,
        },
        url: `${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${deal.urlPath.replace(
          '/deals',
          '/find',
        )}`,
      },
      position: index,
    };
  };
  const data = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: deals?.map((deal, index) => {
      return ListItem({ deal, index });
    }),
  };

  return (
    <>
      <script
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        key="find-snippet"
        type="application/ld+json"
      />
    </>
  );
};

StructuredData.propTypes = {
  deals: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default StructuredData;
